import Globals from "@/components/globals";
import cacheService from "@/services/cache";
import { ROUTES as forecastRoutes } from "@/components/forecasts/router";
import router from "@/router";

export default {
    async save(zone, accessUserPlugin, noRefresh = false) {
        cacheService.set("currentZoneId", zone.id);
        cacheService.setRem3rchUserRoles(null);
        cacheService.setRem3rchUserProfiles(null);
        accessUserPlugin.roles = null;
        await accessUserPlugin.reInit();

        sessionStorage.setItem("targetUrl", "/");

        if (router.currentRoute.name === "ForecastWindowDetail") {
            sessionStorage.setItem("targetUrl", forecastRoutes.BASE);
            noRefresh = false;
        }

        Globals.updatePreferences("zones", noRefresh);
    },
    get() {
        let user = cacheService.getRem3rchUser().user;
        let currentBrand = user.brands.find(brand => brand.id == cacheService.getCurrentBrandId());
        return currentBrand.zones.find(zone => zone.id == cacheService.getCurrentZoneId()) || undefined;
    }
};



// WEBPACK FOOTER //
// ./src/services/currentZone.js